export default __webpack_public_path__ + "static/media/Basement.522ce7ca.jpg";